export const WHATSAPP_BUTTON_TYPES = [
  { value: "website", label: "Website" },
  { value: "phone", label: "Phone number" },
  { value: "copy_code", label: "Copy offer code" },
];

export const WHATSAPP_HEADER_TYPES = [
  { value: "text", label: "Text" },
  { value: "image", label: "Image" },
  { value: "video", label: "Video" },
  { value: "document", label: "Document" },
  { value: "location", label: "Location" },
];

export const WHATSAPP_TEMPLATE_LANGUAGES = [
  { label: "Afrikaans", value: "af" },
  { label: "Albanian", value: "sq" },
  { label: "Arabic", value: "ar" },
  { label: "Arabic (EGY)", value: "ar_EG" },
  { label: "Arabic (UAE)", value: "ar_AE" },
  { label: "Arabic (LBN)", value: "ar_LB" },
  { label: "Arabic (MAR)", value: "ar_MA" },
  { label: "Arabic (QAT)", value: "ar_QA" },
  { label: "Azerbaijani", value: "az" },
  { label: "Belarusian", value: "be_BY" },
  { label: "Bengali", value: "bn" },
  { label: "Bengali (IND)", value: "bn_IN" },
  { label: "Bulgarian", value: "bg" },
  { label: "Catalan", value: "ca" },
  { label: "Chinese (CHN)", value: "zh_CN" },
  { label: "Chinese (HKG)", value: "zh_HK" },
  { label: "Chinese (TAI)", value: "zh_TW" },
  { label: "Croatian", value: "hr" },
  { label: "Czech", value: "cs" },
  { label: "Danish", value: "da" },
  { label: "Dari", value: "prs_AF" },
  { label: "Dutch", value: "nl" },
  { label: "Dutch (BEL)", value: "nl_BE" },
  { label: "English", value: "en" },
  { label: "English (UK)", value: "en_GB" },
  { label: "English (US)", value: "en_US" },
  { label: "English (UAE)", value: "en_AE" },
  { label: "English (AUS)", value: "en_AU" },
  { label: "English (CAN)", value: "en_CA" },
  { label: "English (GHA)", value: "en_GH" },
  { label: "English (IRL)", value: "en_IE" },
  { label: "English (IND)", value: "en_IN" },
  { label: "English (JAM)", value: "en_JM" },
  { label: "English (MYS)", value: "en_MY" },
  { label: "English (NZL)", value: "en_NZ" },
  { label: "English (QAT)", value: "en_QA" },
  { label: "English (SGP)", value: "en_SG" },
  { label: "English (UGA)", value: "en_UG" },
  { label: "English (ZAF)", value: "en_ZA" },
  { label: "Estonian", value: "et" },
  { label: "Filipino", value: "fil" },
  { label: "Finnish", value: "fi" },
  { label: "French", value: "fr" },
  { label: "French (BEL)", value: "fr_BE" },
  { label: "French (CAN)", value: "fr_CA" },
  { label: "French (CHE)", value: "fr_CH" },
  { label: "French (CIV)", value: "fr_CI" },
  { label: "French (MAR)", value: "fr_MA" },
  { label: "Georgian", value: "ka" },
  { label: "German", value: "de" },
  { label: "German (AUT)", value: "de_AT" },
  { label: "German (CHE)", value: "de_CH" },
  { label: "Greek", value: "el" },
  { label: "Gujarati", value: "gu" },
  { label: "Hausa", value: "ha" },
  { label: "Hebrew", value: "he" },
  { label: "Hindi", value: "hi" },
  { label: "Hungarian", value: "hu" },
  { label: "Indonesian", value: "id" },
  { label: "Irish", value: "ga" },
  { label: "Italian", value: "it" },
  { label: "Japanese", value: "ja" },
  { label: "Kannada", value: "kn" },
  { label: "Kazakh", value: "kk" },
  { label: "Kinyarwanda", value: "rw_RW" },
  { label: "Korean", value: "ko" },
  { label: "Kyrgyz (Kyrgyzstan)", value: "ky_KG" },
  { label: "Lao", value: "lo" },
  { label: "Latvian", value: "lv" },
  { label: "Lithuanian", value: "lt" },
  { label: "Macedonian", value: "mk" },
  { label: "Malay", value: "ms" },
  { label: "Malayalam", value: "ml" },
  { label: "Marathi", value: "mr" },
  { label: "Norwegian", value: "nb" },
  { label: "Pashto", value: "ps_AF" },
  { label: "Persian", value: "fa" },
  { label: "Polish", value: "pl" },
  { label: "Portuguese (BR)", value: "pt_BR" },
  { label: "Portuguese (POR)", value: "pt_PT" },
  { label: "Punjabi", value: "pa" },
  { label: "Romanian", value: "ro" },
  { label: "Russian", value: "ru" },
  { label: "Serbian", value: "sr" },
  { label: "Sinhala", value: "si_LK" },
  { label: "Slovak", value: "sk" },
  { label: "Slovenian", value: "sl" },
  { label: "Spanish", value: "es" },
  { label: "Spanish (ARG)", value: "es_AR" },
  { label: "Spanish (CHL)", value: "es_CL" },
  { label: "Spanish (COL)", value: "es_CO" },
  { label: "Spanish (CRI)", value: "es_CR" },
  { label: "Spanish (DOM)", value: "es_DO" },
  { label: "Spanish (ECU)", value: "es_EC" },
  { label: "Spanish (HND)", value: "es_HN" },
  { label: "Spanish (MEX)", value: "es_MX" },
  { label: "Spanish (PAN)", value: "es_PA" },
  { label: "Spanish (PER)", value: "es_PE" },
  { label: "Spanish (SPA)", value: "es_ES" },
  { label: "Spanish (URY)", value: "es_UY" },
  { label: "Swahili", value: "sw" },
  { label: "Swedish", value: "sv" },
  { label: "Tamil", value: "ta" },
  { label: "Telugu", value: "te" },
  { label: "Thai", value: "th" },
  { label: "Turkish", value: "tr" },
  { label: "Ukrainian", value: "uk" },
  { label: "Urdu", value: "ur" },
  { label: "Uzbek", value: "uz" },
  { label: "Vietnamese", value: "vi" },
  { label: "Zulu", value: "zu" },
];

export const WHATSAPP_TEMPLATE_STATUS_COLORS = {
  publishing: "blue",
  in_review: "amber",
  approved: "green",
  rejected: "red",
  failed: "red",
};

export const WHATSAPP_TEMPLATE_STATUS_LABELS = {
  publishing: "Publishing",
  in_review: "In review",
  approved: "Approved",
  rejected: "Rejected",
  failed: "Failed",
};

export const DEFAULT_WHATSAPP_TEMPLATE = {
  name: "Weekend offer",
  headerType: "text",
  headerMediaLabel: "",
  headerAttachment: null,
  headerEnabled: true,
  headerText: "Weekend special",
  body: "Hi there, enjoy 20% off your next visit this weekend. Show this WhatsApp message when you arrive.",
  footerEnabled: true,
  footerText: "Valid until Sunday. Terms apply.",
  buttons: [
    {
      id: "btn-1",
      type: "website",
      label: "Book now",
      value: "https://example.com/book",
    },
  ],
};

export function getWhatsappTemplateStatusLabel(status, qualityScore) {
  const label = WHATSAPP_TEMPLATE_STATUS_LABELS[status];
  const normalizedQualityScore = String(qualityScore || "").trim().toUpperCase();

  if (status === "approved" && normalizedQualityScore) {
    return `${label} - ${normalizedQualityScore}`;
  }

  return label || "";
}

export function getWhatsappButtonTypeConfig(type) {
  return WHATSAPP_BUTTON_TYPES.find((buttonType) => buttonType.value === type) || WHATSAPP_BUTTON_TYPES[0];
}

export function getWhatsappButtonValueLabel(type) {
  if (type === "phone") return "Phone number";
  if (type === "copy_code") return "Offer code";
  return "Website URL";
}

export function getWhatsappHeaderTypeLabel(type) {
  if (type === "image") return "Image";
  if (type === "video") return "Video";
  if (type === "document") return "Document";
  if (type === "location") return "Location";
  if (type === "none") return "None";
  return "Text";
}
